import { init as initApm } from '@elastic/apm-rum';
var APM_RUM_CORE_NAME_UNKNOWN = "Unknown";
var internalApm = null;
var config = {
    ignoreLocalhost: true,
    sampleRate: 0.25
};
var localhostCheck = function () {
    // Ignore localhost unless we specifically override
    return config.ignoreLocalhost && window.location.hostname.indexOf("localhost") >= 0;
};
var apmService = {
    init: function (appName, envName, url, configOverrides, transactionNameFn) {
        // Set defaults based on environment
        if (envName.toLowerCase() === "prod" || envName.toLowerCase() === "stage") {
            config.sampleRate = 1.0;
        }
        // Process configuration overrides
        if (configOverrides) {
            for (var prop in configOverrides) {
                if (configOverrides.hasOwnProperty(prop)) {
                    config[prop] = configOverrides[prop];
                }
            }
        }
        if (localhostCheck())
            return;
        // Only run init once
        if (internalApm !== null)
            throw "EngieApmService is already initialized.";
        var pathName = window.location.pathname.split(";")[0];
        var trxName = transactionNameFn ? transactionNameFn(pathName) : pathName;
        internalApm = initApm({
            serviceName: envName + "-" + appName,
            serverUrl: url,
            pageLoadTransactionName: trxName,
            environment: envName,
            transactionSampleRate: config.sampleRate
        });
        // addFilter allows capture of route changes
        internalApm.addFilter(function (payload) {
            if (payload.data) {
                payload.data.forEach(function (element) {
                    if (element.name === APM_RUM_CORE_NAME_UNKNOWN) {
                        var pathNameRC = window.location.pathname.split(";")[0];
                        var trxNameRC = transactionNameFn ? transactionNameFn(pathNameRC) : pathNameRC;
                        element.name = trxNameRC;
                    }
                });
            }
            return payload;
        });
    },
    setUser: function (userId, userName, userEmail) {
        if (localhostCheck())
            return;
        // Must be initialized first
        if (internalApm === null)
            throw "EngieApmService must be initialized before setting user context.";
        internalApm.setUserContext({
            id: userId,
            username: userName,
            email: userEmail
        });
    },
    captureError: function (error) {
        if (localhostCheck())
            return;
        // Must be initialized first
        if (internalApm === null)
            return;
        internalApm.captureError(error);
    },
    startTransaction: function (name, type) {
        if (localhostCheck())
            return;
        if (internalApm === null)
            return;
        return internalApm.startTransaction(name, type);
    },
    startSpan: function (name) {
        if (localhostCheck())
            return;
        if (internalApm === null)
            return;
        throw "startSpan method does not work in versions 3+; use startTransaction then <transaction>.startSpan, or startTransactionAndSpan";
    },
    startTransactionAndSpan: function (trxName, trxType, spanName, spanType) {
        var trx = apmService.startTransaction(trxName, trxType);
        var span = trx.startSpan(spanName, spanType);
        return {
            transaction: trx,
            span: span,
            end: function () { span.end(); trx.end(); }
        };
    },
    sliObservable: function (options) {
        if (!options.sliGroup || !options.sliName || !options.observableFn)
            throw "sliObservable requires the sliGroup, sliName, and observableFn parameters";
        if (localhostCheck()) {
            options.observableFn().subscribe(function (data) {
                if (options.nextFn)
                    options.nextFn(data);
            }, function (error) {
                if (options.errorFn)
                    options.errorFn(error);
            });
        }
        else {
            if (internalApm === null)
                return;
            var trx_1 = apmService.startTransaction(options.sliName, options.sliGroup);
            var span_1 = trx_1.startSpan(options.sliName, "http");
            var observable = options.observableFn();
            observable.subscribe(function (data) {
                span_1.addLabels({ statusCode: "200" });
                if (options.nextLabelsFn)
                    span_1.addLabels(options.nextLabelsFn(data));
                if (options.nextLabelsFn)
                    trx_1.addLabels(options.nextLabelsFn(data));
                if (options.nextFn)
                    options.nextFn(data);
                span_1.end();
                trx_1.end();
            }, function (error) {
                span_1.addLabels({ statusCode: error.status.toString() });
                if (options.errorLabelsFn)
                    span_1.addLabels(options.errorLabelsFn(error));
                if (options.errorFn)
                    options.errorFn(error);
                span_1.end();
                trx_1.end();
            });
            return observable;
        }
    }
};
export { apmService as EngieApmService };
//# sourceMappingURL=engie-apm.service.js.map